import { parseSormBooleanValue } from '@/shared/sorm/format-sorm-semantic-boolean-value'
import { parseSormNumber } from '@/shared/sorm/read-row-value'

export function readSormString(value: unknown): string {
  if (value == null) {
    return ''
  }
  return typeof value === 'string' ? value : String(value)
}

export function readSormNullableString(value: unknown): string | null {
  return value == null ? null : readSormString(value)
}

export function readSormNumber(value: unknown): number {
  return parseSormNumber(value) ?? 0
}

export function readSormNullableNumber(value: unknown): number | null {
  return value == null ? null : readSormNumber(value)
}

export function readSormNullableBoolean(value: unknown): boolean | null {
  if (value === 1 || value === 0) {
    return value === 1
  }
  return parseSormBooleanValue(value)
}
